import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalanderFullService } from './services/calander-full.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    CalanderFullService
  ]
})
export class CalanderModule { }
 